import * as React from 'react';

export function Disconected () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="116"
      height="100"
      fill="none"
      viewBox="0 0 116 100"
    >
      <path
        fill="#DEF6F5"
        d="M22.108 16.012c-7.42 3.969-14.275 9.17-20.37 15.447-2.317 2.387-2.317 5.966 0 8.352s5.793 2.386 8.11 0c6.054-6.517 13.153-11.553 20.863-15.045zM39.7 33.913a53.14 53.14 0 0 0-21.74 14.25c-2.318 2.386-2.318 5.966 0 8.352s5.793 2.386 8.11 0c6.57-6.766 14.466-11.144 23.185-12.878zM64.056 43.208 52.209 31.152a57 57 0 0 1 5.725-.29c15.063 0 29.547 5.966 39.975 17.301 2.317 2.386 2.317 5.966 0 8.352-1.159 1.193-2.317 1.79-4.055 1.79-1.49 0-2.554-.438-3.558-1.315l-.498-.475c-7.207-7.421-16.008-11.97-25.742-13.307M60.224 54.799 80.233 75.16c-.722.297-1.444.445-2.022.445-1.49 0-2.553-.438-3.557-1.315l-.498-.475c-8.69-8.948-23.174-8.948-31.864 0-2.317 2.387-5.793 2.387-8.11 0-2.14-2.202-2.304-5.422-.494-7.78l.493-.571c5.794-7.16 14.484-10.739 23.753-10.739q1.152 0 2.29.074M42.074 20.839l-9.353-9.518A75.3 75.3 0 0 1 57.934 7c21.436 0 41.134 8.949 56.197 24.46 2.317 2.386 2.317 5.965 0 8.351-1.159 1.193-2.318 1.79-4.056 1.79s-2.897-.597-4.055-1.79c-12.746-13.72-30.126-20.88-48.086-20.88-5.375 0-10.697.642-15.86 1.908"
      />
      <path
        fill="#ABE1DD"
        fillRule="evenodd"
        d="m21.345 30.002-8.306-8.306a81 81 0 0 1 6.87-4.444l8.587 8.587a65 65 0 0 0-7.151 4.163m17.278 17.277-8.768-8.767a53.4 53.4 0 0 1 7.578-3.736l9.428 9.427a42.5 42.5 0 0 0-8.238 3.076m19.844 19.845L47.664 56.32c3.09-.998 6.374-1.523 9.74-1.572L78.28 75.623h-.069c-1.49 0-2.553-.438-3.557-1.314l-.498-.475c-4.284-4.412-9.977-6.649-15.689-6.71"
        clipRule="evenodd"
      />
      <path
        stroke="#58C3BB"
        strokeWidth="0.5"
        d="m18.139 48.356.005-.005a52.9 52.9 0 0 1 21.488-14.132l9.123 9.284c-8.593 1.804-16.374 6.173-22.864 12.856-2.22 2.286-5.533 2.286-7.752 0-2.223-2.289-2.223-5.714 0-8.003Zm46.036-5.365-11.42-11.622a56 56 0 0 1 5.18-.238c14.996 0 29.412 5.94 39.79 17.22l.005.005c2.223 2.29 2.223 5.714 0 8.003-.565.582-1.12 1.008-1.736 1.29-.614.28-1.302.424-2.14.424-1.426 0-2.431-.414-3.389-1.25l-.491-.467c-7.222-7.436-16.042-12.006-25.8-13.365Zm-4.062 12.07 19.673 20.02c-.575.196-1.127.293-1.575.293-1.426 0-2.43-.415-3.388-1.25l-.491-.468c-8.789-9.046-23.432-9.045-32.22.004-2.218 2.285-5.532 2.285-7.751 0-2.052-2.113-2.209-5.19-.48-7.45l.49-.564.005-.007c5.739-7.091 14.353-10.645 23.558-10.645q1.095 0 2.179.067ZM1.917 31.652c6.033-6.212 12.81-11.367 20.144-15.313l8.221 8.366c-7.613 3.5-14.624 8.504-20.614 14.953-2.22 2.283-5.532 2.282-7.75-.002-2.224-2.29-2.224-5.715 0-8.004ZM57.934 18.7c-5.346 0-10.642.632-15.781 1.88l-8.978-9.135a75 75 0 0 1 24.76-4.176c21.362 0 40.997 8.917 56.016 24.383 2.223 2.29 2.223 5.714 0 8.004-.565.581-1.119 1.007-1.735 1.289-.614.28-1.302.424-2.141.424s-1.527-.143-2.141-.424-1.169-.707-1.733-1.287C93.407 25.885 75.961 18.7 57.934 18.7Z"
      />
      <path
        fill="#DEF6F5"
        fillRule="evenodd"
        stroke="#58C3BB"
        strokeLinecap="round"
        strokeWidth="0.5"
        d="M8.916 2.055a3.406 3.406 0 0 1 4.877 0l88.658 90.215a3.553 3.553 0 0 1 0 4.962 3.406 3.406 0 0 1-4.876 0L8.916 7.018a3.553 3.553 0 0 1 0-4.963Z"
        clipRule="evenodd"
      />
      <ellipse
        cx="58.001"
        cy="89.5"
        fill="#DEF6F5"
        stroke="#58C3BB"
        strokeWidth="0.5"
        rx="9.419"
        ry="9.5"
      />
    </svg>
  );
}
